// ========================================
// FILE: components/review/CompanyInfoCard.jsx
// ========================================

import { Building2, Mail, Phone, MapPin, User, KeyRound } from "lucide-react";

// ========================================
// INFO CARD
// ========================================

const InfoCard = ({ icon: Icon, label, value }) => {
  return (
    <div
      className="
        flex items-start gap-3

        p-4 rounded-2xl

        border border-slate-200
        dark:border-slate-800

        bg-slate-50
        dark:bg-slate-950/50
      "
    >
      {/* ICON */}

      <div
        className="
          w-10 h-10 rounded-xl
          flex items-center justify-center
          flex-shrink-0

          bg-gradient-to-br
          from-teal-500
          to-emerald-500

          text-white
          shadow-sm
        "
      >
        <Icon className="w-4 h-4" />
      </div>

      {/* CONTENT */}

      <div className="min-w-0 flex-1">
        <p
          className="
            text-[11px]
            font-medium
            uppercase
            tracking-wider

            text-slate-500
            dark:text-slate-400
          "
        >
          {label}
        </p>

        <p
          className="
            mt-1
            text-sm font-semibold

            text-slate-800
            dark:text-white

            break-words
          "
        >
          {value || "-"}
        </p>
      </div>
    </div>
  );
};

// ========================================
// MAIN COMPONENT
// ========================================

const CompanyInfoCard = ({ formData }) => {
  return (
    <div className="space-y-6">
      {/* ======================================== */}
      {/* COMPANY INFORMATION */}
      {/* ======================================== */}

      <div
        className="
          rounded-3xl
          border border-slate-200 dark:border-slate-800
          bg-white dark:bg-slate-900
          p-6
          shadow-sm
        "
      >
        {/* HEADER */}

        <div className="flex items-center gap-3 mb-6">
          <div
            className="
              w-11 h-11 rounded-2xl
              flex items-center justify-center

              bg-gradient-to-br
              from-teal-500
              to-emerald-500

              text-white
              shadow-lg
            "
          >
            <Building2 className="w-5 h-5" />
          </div>

          <div>
            <h3
              className="
                text-lg font-bold
                text-slate-800 dark:text-white
              "
            >
              Company Information
            </h3>

            <p
              className="
                text-sm
                text-slate-500 dark:text-slate-400
              "
            >
              Review company profile details
            </p>
          </div>
        </div>

        {/* GRID */}

        <div className="grid md:grid-cols-2 gap-4">
          <InfoCard
            icon={Building2}
            label="Company Name"
            value={formData?.COMPANY_NAME}
          />

          <InfoCard
            icon={Mail}
            label="Company Email"
            value={formData?.PROFILE_EMAILID}
          />

          <InfoCard
            icon={Phone}
            label="Phone"
            value={formData?.PROFILE_PHONE}
          />

          <InfoCard
            icon={MapPin}
            label="Address"
            value={formData?.PROFILE_ADDRESS1}
          />

          <InfoCard
            icon={MapPin}
            label="Country"
            value={formData?.PROFILE_COUNTRY}
          />

          <InfoCard
            icon={MapPin}
            label="State"
            value={formData?.PROFILE_REGION}
          />
        </div>
      </div>

      {/* ======================================== */}
      {/* USER CREDENTIALS */}
      {/* ======================================== */}

      <div
        className="
          rounded-3xl
          border border-slate-200 dark:border-slate-800
          bg-white dark:bg-slate-900
          p-6
          shadow-sm
        "
      >
        {/* HEADER */}

        <div className="flex items-center gap-3 mb-6">
          <div
            className="
              w-11 h-11 rounded-2xl
              flex items-center justify-center

              bg-gradient-to-br
              from-violet-500
              to-fuchsia-500

              text-white
              shadow-lg
            "
          >
            <User className="w-5 h-5" />
          </div>

          <div>
            <h3
              className="
                text-lg font-bold
                text-slate-800 dark:text-white
              "
            >
              User Credentials
            </h3>

            <p
              className="
                text-sm
                text-slate-500 dark:text-slate-400
              "
            >
              Primary account information
            </p>
          </div>
        </div>

        {/* GRID */}

        <div className="grid md:grid-cols-2 gap-4">
          {/* FIRST NAME */}

          <InfoCard
            icon={User}
            label="First Name"
            value={formData?.PROFILE_FIRSTNAME}
          />

          {/* LAST NAME */}

          <InfoCard
            icon={User}
            label="Last Name"
            value={formData?.PROFILE_LASTNAME}
          />

          {/* EMAIL */}

          <InfoCard
            icon={Mail}
            label="Email"
            value={formData?.PROFILE_EMAILID}
          />

          {/* PHONE */}

          <InfoCard
            icon={Phone}
            label="Phone"
            value={formData?.PROFILE_PHONE}
          />

          {/* USERNAME */}

          <InfoCard
            icon={KeyRound}
            label="Username"
            value={formData?.PROFILE_USERNAME}
          />

          {/* COMPANY */}

          <InfoCard
            icon={Building2}
            label="Company"
            value={formData?.COMPANY_NAME}
          />

          {/* COUNTRY */}

          <InfoCard
            icon={MapPin}
            label="Country"
            value={formData?.PROFILE_COUNTRY}
          />

          {/* ADDRESS */}

          <InfoCard
            icon={MapPin}
            label="Address"
            value={formData?.PROFILE_ADDRESS1}
          />
        </div>
      </div>
    </div>
  );
};

export default CompanyInfoCard;
